/**
 * useAnalytics
 *
 * Primary responsibilities:
 * - Provide a React hook for tracking events
 * - Abstract away analytics implementation details
 * - Allow components to easily track user interactions
 *
 * Dependencies:
 * - lib/analytics/track for event tracking functions
 */

import { useCallback } from 'react'
import { track, trackServer, EventName, EventNames } from '@/lib/analytics/track'

export function useAnalytics() {
  /**
   * Track a client-side event
   */
  const trackEvent = useCallback(
    (eventName: EventName, properties?: Record<string, string | number | boolean | null>) => {
      track(eventName, properties)
    },
    []
  )

  /**
   * Track a server-side event
   */
  const trackServerEvent = useCallback(
    async (eventName: EventName, properties?: Record<string, string | number | boolean | null>) => {
      await trackServer(eventName, properties)
    },
    []
  )

  return {
    track: trackEvent,
    trackServer: trackServerEvent,
    EventNames
  }
}
